import { type ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';

import { AppErrorFallback } from '@/app/components/AppErrorFallback';
import { captureUnexpectedError } from '@/error-reporting/utils/captureUnexpectedError';

type PageErrorBoundaryProps = {
  children: ReactNode;
};

// A crashing page keeps the navigation around it, and going to another page
// clears the error.
export const PageErrorBoundary = ({ children }: PageErrorBoundaryProps) => {
  const location = useLocation();

  return (
    <ErrorBoundary
      FallbackComponent={AppErrorFallback}
      onError={captureUnexpectedError}
      resetKeys={[location.pathname]}
    >
      {children}
    </ErrorBoundary>
  );
};
